import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimString',
  standalone: true
})
export class TrimStringPipe implements PipeTransform {

  transform = (value: string, length: number) => value?.length >= length ? ` ${value.slice(0 , length)}...` : value  ;
  

}
